import { useGetFetch } from '../reactQuery';
import { STEP_API } from '../../../constant/api_url';
import { Input } from '../../../types/input.types';

export const useAvailableInputsForStepById = (id: number | string) => {
  return useGetFetch<Input[]>(`${STEP_API}/${id}/available-inputs`);
};
